import Auth from "../../Auth";
import { NavLink } from "react-router-dom";
import logo from "./images/newsmaxplus-logo-2025.svg";

import { HeaderStyled, LogoStyled /*, StyledPlus*/ } from "./HeaderStyled";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Header = ({ isHomePage, onGiftToggle, isGiftMode }) => {
  return (
    <HeaderStyled isHomePage={isHomePage}>
      <div className="container-fluid">
        <nav className="navbar row bg-body-tertiary">
          <div className="container-fluid">
            <div>
              <NavLink to="/">
                <LogoStyled src={logo} />
              </NavLink>
            </div>
            <div
              className={useLocation().pathname === "/winback" ? "hide" : "show"}
            >
              <Auth onGiftToggle={onGiftToggle} isGiftMode={isGiftMode} />
            </div>
          </div>
        </nav>
      </div>
    </HeaderStyled>
  );
};

export default Header;
